import { io } from "socket.io-client";

let socket;

export const connectSocket = () => {
  const token = localStorage.getItem('token');

  if (!token) {
    console.warn("No token found, skipping socket connection");
    return null;
  }

  socket = io(process.env.REACT_APP_API_URL, {
    auth: {
      token,
    },
  });

  socket.on("connect", () => {
    // console.log("Connected to Socket.IO server");
  });

  return socket;
};

export const getSocket = () => {
  return socket;
};